function objectWithoutProperties(obj, exclude) {
  var target = {}
  for (var k in obj)
    if (
      Object.prototype.hasOwnProperty.call(obj, k) &&
      exclude.indexOf(k) === -1
    )
      target[k] = obj[k]
  return target
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return Object.keys(_vm.collaborators).length
    ? _c(
        "div",
        _vm._l(_vm.collaborators, function (ref) {
          var givenName = ref.givenName
          var familyName = ref.familyName
          var rest = objectWithoutProperties(ref, ["givenName", "familyName"])
          var data = rest
          return _c(
            "a",
            {
              key: data.username,
              staticClass: "dropdown-item clickable pl-2 d-flex flex-row",
              on: {
                click: function ($event) {
                  return _vm.changeOwner(
                    Object.assign(
                      {},
                      { givenName: givenName, familyName: familyName },
                      data
                    )
                  )
                },
              },
            },
            [
              _c(
                "profile-avatar",
                _vm._b(
                  { staticClass: "client-profile-owner-avatar" },
                  "profile-avatar",
                  Object.assign(
                    {},
                    { givenName: givenName, familyName: familyName },
                    data
                  ),
                  false
                )
              ),
              _vm._v(" "),
              _c("span", { staticClass: "ml-2" }, [
                _vm._v(_vm._s(_vm._f("nameFormat")(givenName, familyName))),
              ]),
            ],
            1
          )
        }),
        0
      )
    : _c("div", [
        _c(
          "a",
          { staticClass: "disabled dropdown-item", attrs: { disabled: "" } },
          [
            _vm._v(
              _vm._s(
                _vm.$t("client-profile.messages.inOrderToTransferThisClient")
              )
            ),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }